export default __webpack_public_path__ + "media/images/checkbox-a1b3637b0046f5ca6e5877e1c01bc18b.svg";